import { useState } from "react";
import { Send, MapPin, Phone, Instagram, Clock } from "lucide-react";
import { ORG, buildWhatsAppLink } from "../data/siteData";

const ASSUNTOS = ["Matrícula / Aulas de Judô", "Projetos Sociais", "Doações e Parcerias", "Transparência / Documentos", "Outro assunto"];

export const Contato = () => {
  const [nome, setNome] = useState("");
  const [assunto, setAssunto] = useState(ASSUNTOS[0]);
  const [mensagem, setMensagem] = useState("");

  const enviar = (e) => {
    e.preventDefault();
    window.open(buildWhatsAppLink({ nome, assunto, mensagem }), "_blank", "noopener");
  };

  return (
    <section id="contato" className="relative bg-[#0F0F11] py-24 overflow-hidden" data-testid="contato-section">
      <span aria-hidden className="absolute -left-10 top-10 text-[14rem] leading-none font-heading text-white/[0.03] select-none pointer-events-none">勇</span>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 relative z-10">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#DC2626] mb-4">Contato</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F8FAF8] tracking-tight" data-testid="contato-title">
            Fale direto com a associação no WhatsApp
          </h2>
          <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed">
            Preencha o formulário e sua mensagem será enviada diretamente para o WhatsApp da AMACLI. Você também pode nos chamar pelos canais abaixo.
          </p>
          <ul className="mt-10 space-y-5 text-sm">
            <li className="flex items-start gap-3 text-zinc-300">
              <Phone className="h-5 w-5 text-[#DC2626] shrink-0 mt-0.5" />
              <div><p className="font-semibold text-zinc-200">WhatsApp</p><a href={`https://wa.me/${ORG.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="contato-whatsapp-direto" className="text-zinc-400 hover:text-white transition-colors duration-200">{ORG.whatsappFormatado}</a></div>
            </li>
            <li className="flex items-start gap-3 text-zinc-300">
              <Instagram className="h-5 w-5 text-[#DC2626] shrink-0 mt-0.5" />
              <div><p className="font-semibold text-zinc-200">Instagram</p><a href={ORG.instagram} target="_blank" rel="noopener noreferrer" data-testid="contato-instagram-link" className="text-zinc-400 hover:text-white transition-colors duration-200">{ORG.instagramHandle}</a></div>
            </li>
            <li className="flex items-start gap-3 text-zinc-300">
              <Clock className="h-5 w-5 text-[#DC2626] shrink-0 mt-0.5" />
              <div><p className="font-semibold text-zinc-200">Dias de treino</p><p className="text-zinc-400" data-testid="contato-horarios">Segundas, quartas e sextas-feiras</p></div>
            </li>
            <li className="flex items-start gap-3 text-zinc-300">
              <MapPin className="h-5 w-5 text-[#DC2626] shrink-0 mt-0.5" />
              <div><p className="font-semibold text-zinc-200">Endereço</p><p className="text-zinc-400">{ORG.endereco}</p></div>
            </li>
          </ul>
        </div>

        <form onSubmit={enviar} className="bg-[#202026] border border-white/10 rounded-2xl p-8 space-y-5" data-testid="contato-form">
          <div>
            <label htmlFor="contato-nome" className="block text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-2">Seu nome</label>
            <input id="contato-nome" type="text" required value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome completo" data-testid="contato-input-nome" className="w-full bg-[#0F0F11] border border-white/10 focus:border-[#DC2626] rounded-lg px-4 py-3 text-sm text-zinc-200 placeholder-zinc-600 outline-none transition-colors duration-200" />
          </div>
          <div>
            <label htmlFor="contato-assunto" className="block text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-2">Assunto</label>
            <select id="contato-assunto" value={assunto} onChange={(e) => setAssunto(e.target.value)} data-testid="contato-select-assunto" className="w-full bg-[#0F0F11] border border-white/10 focus:border-[#DC2626] rounded-lg px-4 py-3 text-sm text-zinc-200 outline-none transition-colors duration-200">
              {ASSUNTOS.map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <div>
            <label htmlFor="contato-mensagem" className="block text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-2">Mensagem</label>
            <textarea id="contato-mensagem" required rows={5} value={mensagem} onChange={(e) => setMensagem(e.target.value)} placeholder="Escreva sua mensagem..." data-testid="contato-textarea-mensagem" className="w-full bg-[#0F0F11] border border-white/10 focus:border-[#DC2626] rounded-lg px-4 py-3 text-sm text-zinc-200 placeholder-zinc-600 outline-none resize-none transition-colors duration-200" />
          </div>
          <button type="submit" data-testid="contato-botao-enviar" className="w-full inline-flex items-center justify-center gap-2 bg-[#DC2626] hover:bg-[#EF4444] text-white font-semibold px-6 py-3.5 rounded-full transition-colors duration-200">
            <Send className="h-4 w-4" /> Enviar pelo WhatsApp
          </button>
          <p className="text-[11px] text-zinc-500 text-center">Ao enviar, o WhatsApp abrirá com sua mensagem pronta para {ORG.whatsappFormatado}.</p>
        </form>
      </div>
    </section>
  );
};
